import $ from 'jquery';
import { track } from 'util/analytics';
import { onDOMReady } from 'util/onload';
import { showConfirmationModal } from 'util/ui';
import * as mathjaxLoader from 'util/mathjax_loader';

/**
 * Check if inline latex overflows and set display: inline-block
 * @param {JQuery} [$container]
 */
function checkLatexOverflow($container) {
    const $inlineLatex = $container ? $container.find('.latexprocessor-inline') : $('.latexprocessor-inline');
    $inlineLatex.each((i, elem) => {
        const $elem = $(elem);
        const width = $elem.outerWidth();
        const maxWidth = $elem.parent().outerWidth();
        if (width > maxWidth) {
            $elem.addClass('overflowed');
        }
    });
}


/**
 * Scale svg elements to the width of their containers. Note: this function assumes the selector
 * is the parent container for the svgs.
 *
 * @param {JQuery} $containers
 * @param {number} [tolerance] - Minimum scale for an element to avoid shrinking too small
 */
function scaleSVG($containers, tolerance = 0.65) {
    $containers.each((i, container) => {
        const $svgs = $(container).find('svg');

        if ($svgs.length > 0) {
            $svgs.each((j, elem) => {
                const $svg = $(elem);

                // reset to original width
                const originalWidth = $svg.data('orig-width');
                if (!originalWidth) {
                    $svg.data('orig-width', parseFloat($svg[0].style.width));
                } else {
                    $svg[0].style.width = `${originalWidth}ex`;
                }

                // add 4px buffer to outer container width to avoid scaling things unnecessarily
                const containerWidth = $svg.parent().width() + 4;
                const svgWidthEx = parseInt($svg[0].style.width, 10);
                const svgWidthPx = ~~($svg.width());
                const scaledWidth = ~~((svgWidthEx * containerWidth) / svgWidthPx);

                if (svgWidthPx > containerWidth && (scaledWidth / svgWidthEx) >= tolerance) {
                    $svg[0].style.width = `${scaledWidth}ex`;
                }
            });
        }
    });
}


/** @param $containers */
function updateMathjax($containers) {
    $containers.each((i, container) => {
        const $container = $(container);
        mathjaxLoader.loadForElement($container);
        $container.parent().find('.uses-latex, .latex').css('visibility', 'visible');
    });
}


/**
 * @controller
 * Direct users to an equation editor.
 * @param {JQuery} $trigger
 */
function equationEditorTrigger($trigger) {
    const trackAction = (id) => {
        track('ui', {
            action: 'click',
            element_type: id,
            element_id: 'link',
        });
    };

    $trigger.on('click', (e) => {
        const data = $trigger.data();

        trackAction(data.axClicked);

        if (!e.metaKey) {
            e.preventDefault();
            showConfirmationModal({
                text: $trigger.data('text'),
            }).then((confirmed) => {
                if (confirmed) {
                    trackAction(data.axConfirmed);
                    window.open($trigger.attr('href'));
                }
            });
        }
    });
}


onDOMReady(() => {
    checkLatexOverflow();
});


export {
    checkLatexOverflow as checkOverflow,
    scaleSVG,
    updateMathjax,
    equationEditorTrigger,
};
